import { ApiEndpoint } from './ApiDefinition';


export type WorkpageListStubDTO = {
  id: number
  order: number
  slug: string
  name: string
  isAdmin: boolean
  image: JSON
}

export type WorkpageInfoDTO = {
  id: number
  order: number
  slug: string
  name: string
  isAdmin: boolean
  image: JSON
  definition: JSON
}

export const WorkpageApi = {
  list: ApiEndpoint<void, WorkpageListStubDTO[]>({
    url: 'workpages'
  }),
  get: ApiEndpoint<{ id: number }, WorkpageInfoDTO>({
    url: ({id}) => `workpages/${id}`
  }),
};

export default WorkpageApi;
